import {Component, ElementRef, inject, OnDestroy, OnInit, signal, ViewChild,} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {LoadingComponent} from '../../shared/commons/loader/loading.component';
import {AppHeaderComponent} from '../../shared/commons/app-header/app-header.component';
import {NgTemplateOutlet} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FeedbackModalComponent} from '../modal/feedback-modal/feedback-modal.component';
import {NgbdToastGlobalModule} from '../../shared/commons/toast/toast-global.module';
import {NavCollapseDirective} from '../../shared/commons/nav-collapse.directive';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {environment} from '../../../environments/environment';
import {HasAnyRoleDirective} from '../../auth/has-any-role.directive';
import {ManufacturerRest} from '../../service/ManufacturerRest';
import {map, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ResourceAccess, SsoUser} from '../../app.constants';
import {SidebarMenuComponent} from '../../sidebar-menu/sidebar-menu.component';
import {SidebarMenuItemComponent} from '../../sidebar-menu-item/sidebar-menu-item.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  imports: [
    RouterOutlet,
    LoadingComponent,
    AppHeaderComponent,
    RouterLinkActive,
    RouterLink,
    NgTemplateOutlet,
    NgbdToastGlobalModule,
    NavCollapseDirective,
    HasAnyRoleDirective,
    SidebarMenuComponent,
    SidebarMenuItemComponent
  ],
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private modalService = inject(NgbModal);
  private oidcSecurityService = inject(OidcSecurityService)
  manufacturerRest = inject(ManufacturerRest)
  protected readonly environment = environment;
  protected userData: SsoUser;
  private subscription: Subscription;
  protected officialOrAdmin: boolean;
  isTestEnv = signal(environment.test);
  @ViewChild('sideBarMd', { static: false }) sidebarContainer!: ElementRef;

  ngOnInit(): void {
    this.oidcSecurityService.userData$
      .pipe(map(e => e.userData))
      .pipe(filter(e => !!e))
      .subscribe(e => {
        this.userData = e
        this.subscription = this.manufacturerRest.findBySsoUserId().subscribe(e => {
          console.log(`login as e.businessType ${e?.businessType}`)
        });
        const resourceAccess = this.userData as ResourceAccess
        const roles = resourceAccess.resource_access['qrtraces'].roles
        this.officialOrAdmin = roles.includes('admin') || roles.includes('official')
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
          this.collapseMenuMd();
        });
      })
  }

  next() {
    this.router.navigate(['/register/finish']);
  }

  feedBackModal() {
    const modalRef = this.modalService.open(FeedbackModalComponent, {
      size: "md"
    });
  }

  logout() {
    console.log('logout')
    this.oidcSecurityService
      .logoff()
      .subscribe((result) => console.log(result));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  collapseMenuMd(){
    if (this.sidebarContainer) {
      const sidebarMdElement = this.sidebarContainer.nativeElement;
      if (sidebarMdElement) {
        (sidebarMdElement as any).classList.remove('show');
      }
    }
  }
}
